module.exports = __webpack_public_path__ + "public/images/schedule/schedule-tur.ec1c12df8aef63f3ca1fd4dbc9d401ee.svg";